import { render, staticRenderFns } from "./ListaVentas.vue?vue&type=template&id=147ef6ae&"
import script from "./ListaVentas.vue?vue&type=script&lang=js&"
export * from "./ListaVentas.vue?vue&type=script&lang=js&"
import style0 from "./ListaVentas.vue?vue&type=style&index=0&id=147ef6ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports